<ldw-document-toolbar [document]="document" [isReadOnly]="isReadOnly" [allowStatusChange]="isStatusChangeAllowed"
                      [showBookmark]='isBookmarkVisible' (closeSelected)="close()"
                      (statusChanged)="statusHasChanged($event)"></ldw-document-toolbar>
                      <ldw-document-view
  [selectedPlanningJob]="selectedPlanningJob()"
  [document]="document"
  [search]='search'
  [pageNumber]=pageNumber
  [pageZoom]=pageZoom
  [doCloseNotNavigate]='doCloseNotNavigate' #documentView></ldw-document-view>
